module.exports = __webpack_public_path__ + "static/media/card-xcard.9e2bb6d6.png";